import dynamic from 'next/dynamic';
import loading from '../../../../lib/loading';

const DynamicSideBar = dynamic(() => import('../../SideBar'), {
  ssr: false,
  loading,
});

export default DynamicSideBar;
